<template>
  <VPanel class="relative p-6 overflow-hidden">
    <div class="flex justify-between">
      <h1 class="text-lg">مدیریت اتاق ها</h1>

      <a href="#" @click.prevent="modalCreate = true"
         class="flex items-center border border-dark-line rounded-lg px-4 py-3 hover:bg-accent">
        <PlusIcon class="ml-2"/>
        افزودن اتاق
      </a>
    </div>
    <hr class="border-dark-line mt-6">

    <table class="w-full text-right mt-4">
      <thead>
      <tr class="text-sm text-muted">
        <th class="p-4">ردیف</th>
        <th>شماره اتاق</th>
        <th>ظرفیت</th>
        <th>QR</th>
        <th>وضعیت</th>
        <th>عملیات</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(room, index) in rooms"
          :key="room.id">
        <td class="p-8">{{ index + 1 }}</td>
        <td>{{ room.number }}</td>
        <td>{{ room.capacity }}</td>
        <td>
          <a :href="room.qr.path" target="_blank">
            <img :src="room.qr.path" alt="" class="w-12 rounded-lg inline">
          </a>
        </td>
        <td>
          <VBadge :type="room.active ? 'success' : 'danger'">
            {{ room.active ? 'فعال' : 'غیرفعال' }}
          </VBadge>
        </td>
        <td>
          <a href="#" @click.prevent="editRoom = room; modalEdit = true">
            <PenIcon class="text-orange"/>
          </a>
        </td>
      </tr>
      </tbody>
    </table>

    <ModalRoom
        :show="modalCreate"
        @click="modalCreate = !modalCreate"
        @created="roomCreated"/>

    <ModalRoom
        :show="modalEdit"
        @click="modalEdit = !modalEdit"
        :room="editRoom"
        @edited="roomEdited"/>


    <VLoadingScreen :show="loading"/>

  </VPanel>
</template>

<script>
import {getRooms} from "@/API/API";
import VPanel from "@/components/VPanel";
import PlusIcon from "@/components/Icons/PlusIcon";
import VLoadingScreen from "@/components/General/VLoadingScreen";
import VBadge from "@/components/General/VBadge";
import PenIcon from "@/components/Icons/PenIcon";
import ModalRoom from "@/components/Modal/ModalRoom";

export default {
  name: "RoomView",
  components: {ModalRoom, PenIcon, VBadge, VLoadingScreen, PlusIcon, VPanel},
  data() {
    return {
      rooms: [],
      loading: true,
      modalCreate: false,
      modalEdit: false,
      editRoom: {}
    }
  },
  async created() {
    this.rooms = (await getRooms()).data
    this.loading = false
  },
  methods: {
    async roomCreated() {
      this.modalCreate = false
      this.loading = true
      this.rooms = (await getRooms()).data
      this.loading = false
    },
    async roomEdited() {
      this.modalEdit = false
      this.loading = true
      this.rooms = (await getRooms()).data
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>